import currencyFormatter from 'currency-formatter';
// calculate buyback balance
const buybackBalanceElement = document.querySelector<HTMLInputElement>("[js-buyback-balance]");
const buybackPriceElement = document.querySelector<HTMLInputElement>("[js-buyback-price]");

// selected event
if (buybackBalanceElement) {
    checkUpdateMessage();
    updateBuybackPrice();
    // event
    // account selected
    document.addEventListener('account-validation.selected', (e: CustomEvent) => {
        const account = e.detail;
        buybackBalanceElement.value = account.saleBalance;
        buybackBalanceElement.setAttribute("data-salePrice", account.salePrice);

        buybackBalanceElement.dispatchEvent(new Event("change"));

        // set default value
        buybackBalanceElement.dataset["default"] = buybackBalanceElement.value;
        checkUpdateMessage();
    });

    // calculate price
    // event
    buybackBalanceElement.addEventListener('keyup', updateBuybackPrice);
    buybackBalanceElement.addEventListener('change', updateBuybackPrice);

    function updateBuybackPrice(e?) {
        // calculate buyback price
        const salePrice = Number(buybackBalanceElement.getAttribute("data-salePrice") || '');
        const saleBalance = Number(buybackBalanceElement.value || '');
        if (!isNaN(salePrice) && !isNaN(saleBalance)) {
            if (buybackPriceElement) {
                buybackPriceElement.textContent = currencyFormatter.format(salePrice * saleBalance, { code: '', precision: 2 });
            }
        } else {
            if (buybackPriceElement) {
                buybackPriceElement.textContent = '-';
            }
        }
        checkUpdateMessage();
    }
}


// update buyback to buyer/seller
const checkboxInput = document.querySelector<HTMLInputElement>('#ckUpdateBuybackToSeller');
const btnToBuyer = document.querySelector<HTMLButtonElement>('#btnUpdateToBuyer');
const btnToSeller = document.querySelector<HTMLButtonElement>('#btnUpdateToSeller');

if (checkboxInput) {

    // buyer
    if (btnToBuyer) {
        btnToBuyer.addEventListener('click', (e) => {
            e.preventDefault();
            // form
            const form = btnToBuyer.closest<HTMLFormElement>('form');
            if ($(form).valid()) {
                // unchecked
                checkboxInput.checked = false;
                //submit
                form.submit();
            }
        });
    }
    // seller
    if (btnToSeller) {
        btnToSeller.addEventListener('click', (e) => {
            e.preventDefault();
            // form
            const form = btnToBuyer.closest<HTMLFormElement>('form');
            if ($(form).valid()) {
                // unchecked
                checkboxInput.checked = true;
                //submit
                form.submit();
            }
        });
    }

}

function checkUpdateMessage() {
    let show = false;
    // check if value changed
    if (!!buybackBalanceElement.dataset["default"]) {
        const defaultValue = parseFloat(buybackBalanceElement.dataset["default"]);
        if (defaultValue != parseFloat(buybackBalanceElement.value)) {
            show = true;
        }
    }

    const updateMessage = document.querySelector("[js-update-message]");
    if (updateMessage) {
        updateMessage.classList.toggle("d-none", !show);
    }
}
export default undefined;